/* * * created By Xu Peng * */
<template>
  <router-link :to="router" class="table-link">
    <slot />
  </router-link>
</template>

<script>
export default {
  props: {
    router: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="less">
@import url('../../styles/var.less');
.table-link {
  text-decoration-color: @blue;
  color: @blue;
}
</style>
